export * from "./file-link.directive";
